import {Injectable} from '@angular/core';
import {NestApiProvider} from '../nest-api';
import {Observable} from 'rxjs';

@Injectable()
export class PayrollProcessMalayReportApi {
  private readonly service: string = 'payroll';
  private readonly model: string = 'payrollprocessmalayreport';

  constructor(
      private nestApiProvider: NestApiProvider,
  ) {
  }

  public downloadTemplateComponent(
      empStatus: any,
      gender: any,
      religion: string,
      marital: string,
      skip: any,
      limit: any,
      searchByFullname?: any,
  ): Observable<any> {
    const method: string = 'GET';
    const func: string = 'downloadtemplatecomponent';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof empStatus !== 'undefined' && empStatus !== null) urlParams.empStatus = empStatus;
    if (typeof gender !== 'undefined' && gender !== null) urlParams.gender = gender;
    if (typeof religion !== 'undefined' && religion !== null) urlParams.religion = religion;
    if (typeof marital !== 'undefined' && marital !== null) urlParams.marital = marital;
    if (typeof skip !== 'undefined' && skip !== null) urlParams.skip = skip;
    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof searchByFullname !== 'undefined' && searchByFullname !== null) urlParams.search = searchByFullname;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.requestBlob<any>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/payroll-process-malay-report.api.ts